<div class="px-1 py-1 space-y-1 text-center">
    <div class="rounded bg-slate-100 border border-slate-200">
        <div class="px-5 py-5 space-y-5">
            <img src="img/logo.png" class="w-16 h-16 mx-auto">
            <p class="max-w-xl mx-auto">
                Kyovy is a suite of blockchain games designed for a fun, fresh, and fast experience. Every game runs
                entirely on blockchain, ensuring seamless gameplay and true blockchain integration.
            </p>
            <div class="flex flex-wrap justify-center items-stretch gap-1 max-w-5xl mx-auto">
                @for (feature of features(); track $index) {
                <div class="max-w-80">
                    <app-widget-box name="{{feature.caption}}" description="{{feature.description}}"
                        icon="{{feature.icon}}" color="{{feature.color}}">
                    </app-widget-box>
                </div>
                }
            </div>
        </div>
    </div>
    <div class="rounded bg-slate-100 border border-slate-200">
        <div class="px-5 py-5 space-y-5">
            <p class="text-green-600">Kyovy Games</p>
            <p class="max-w-xl mx-auto">
                Enjoy fresh collection of blockchain games
            </p>
            <div class="flex flex-wrap justify-center items-stretch gap-1 max-w-5xl mx-auto">
                @for (game of games(); track $index) {
                <div class="max-w-80">
                    <app-widget-box name="{{game.name}}" description="{{game.description}}" icon="{{game.icon}}"
                        color="{{game.color}}">
                        <div>
                            <app-widget-button (clicked)="navigateToPage(game.id)" heading="{{game.action}}">
                            </app-widget-button>
                        </div>
                    </app-widget-box>
                </div>
                }
            </div>
        </div>
    </div>
    <div class="rounded bg-slate-100 border border-slate-200">
        <div class="px-5 py-5 space-y-5">
            <p class="text-green-600">Kyovy Tools</p>
            <p class="max-w-xl mx-auto">
                Explore rich ecosystem of exciting features
            </p>
            <div class="flex flex-wrap justify-center items-stretch gap-1 max-w-5xl mx-auto">
                @for (tool of tools(); track $index) {
                <div class="max-w-80">
                    <app-widget-box name="{{tool.name}}" description="{{tool.description}}" icon="{{tool.icon}}"
                        color="{{tool.color}}">
                        <div>
                            <app-widget-button (clicked)="navigateToPage(tool.id)" heading="{{tool.action}}">
                            </app-widget-button>
                        </div>
                    </app-widget-box>
                </div>
                }
            </div>
        </div>
    </div>
</div>